export function setMetadata(state, metadata) {
   state.metadata = metadata;
}

export function setLoaded(state, loaded) {
   state.loaded = loaded;
}

export function reset(state) {
   state.metadata = null;
   state.loaded = false;
}
